/**
 * WebApi
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type CompanyStates = 'WaitingForApproval' | 'Approved' | 'Stub' | 'Incomplete';

export const CompanyStates = {
    WaitingForApproval: 'WaitingForApproval' as CompanyStates,
    Approved: 'Approved' as CompanyStates,
    Stub: 'Stub' as CompanyStates,
    Incomplete: 'Incomplete' as CompanyStates
};

